<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="10" md="8" lg="6" xl="5">
            <v-card class="pa-4 pa-md-6">
              <v-img src="/assets/logo.png" max-height="56" contain class="mb-4" />

              <v-alert v-if="hasErrors" type="error" variant="tonal" class="mb-4">
                <div class="font-weight-bold mb-2">{{ pageProps.errorsTitle || "Bitte Eingaben prüfen" }}</div>
                <ul class="ma-0 ps-4">
                  <li v-for="error in pageProps.errors" :key="error">{{ error }}</li>
                </ul>
              </v-alert>

              <h1 class="text-h5 mb-4">{{ pageProps.title }}</h1>

              <v-form :method="pageProps.form.method" :action="pageProps.form.action">
                <input type="hidden" name="authenticity_token" :value="pageProps.csrfToken">
                <input type="hidden" name="_method" :value="pageProps.form._method || 'put'">

                <v-text-field
                  v-for="field in pageProps.form.fields || []"
                  :key="field.name"
                  :name="field.name"
                  :label="field.label"
                  :type="field.type || 'text'"
                  :autocomplete="field.autocomplete"
                  :model-value="field.value"
                  :required="Boolean(field.required)"
                  :hint="field.hint"
                  persistent-hint
                  class="mb-1"
                />

                <v-alert v-if="pageProps.pendingReconfirmation" type="info" variant="tonal" class="my-3">
                  Aktuell ausstehende Bestätigung für: {{ pageProps.pendingReconfirmation }}
                </v-alert>

                <v-btn type="submit" color="primary" block>{{ pageProps.form.submitLabel }}</v-btn>
              </v-form>

              <v-divider class="my-5" />

              <div class="d-flex align-center justify-space-between">
                <div class="text-body-2">Konto löschen</div>
                <v-form method="post" :action="pageProps.cancelForm.action">
                  <input type="hidden" name="authenticity_token" :value="pageProps.csrfToken">
                  <input type="hidden" name="_method" value="delete">
                  <v-btn type="submit" color="error" variant="tonal">{{ pageProps.cancelForm.submitLabel }}</v-btn>
                </v-form>
              </div>

              <div class="mt-4">
                <a :href="pageProps.backPath" class="text-decoration-none">Zurück</a>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  pageProps: {
    type: Object,
    required: true,
  },
});

const hasErrors = computed(() => Array.isArray(props.pageProps.errors) && props.pageProps.errors.length > 0);
</script>
